import { render, staticRenderFns } from "./AppHeader.vue?vue&type=template&id=bb50a5e4&"
import script from "./AppHeader.vue?vue&type=script&lang=js&"
export * from "./AppHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb50a5e4')) {
      api.createRecord('bb50a5e4', component.options)
    } else {
      api.reload('bb50a5e4', component.options)
    }
    module.hot.accept("./AppHeader.vue?vue&type=template&id=bb50a5e4&", function () {
      api.rerender('bb50a5e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppHeader.vue"
export default component.exports